module.exports = __webpack_public_path__ + "media/2-11.88643235.mp4";